export default function todaysDateFormatted (state) {
  return state.today.dateFormatted
}
